export default function FormControl({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`mb-5 ${className ?? ""}`}>{children}</div>;
}
